import ModuleBlockType from "../../../Types/ModuleBlockType";

const ModuleBlock = ({ number, description }: ModuleBlockType) => {
  return (
    <div className="module">
      <h3> {number}</h3>
      <div className="moduleDescription">
        <label>{description}</label>
      </div>
    </div>
  );
};

export default ModuleBlock;
